import { Choice } from '../components/SearchSelect/SearchSelectTypes';
import nonFoxdenProfessions from './config/nonFoxdenProfessions.json';

interface NonFoxdenProfession {
  profession: string;
  remove: boolean;
  usOnly?: boolean;
  canadaOnly?: boolean;
}

const professions: NonFoxdenProfession[] = nonFoxdenProfessions;

export type BrokerCountry = 'US' | 'CA' | undefined;

const shouldRemove = (value: NonFoxdenProfession, country: BrokerCountry) => {
  if (!value.remove) return false;
  // usOnly/canadaOnly removals apply only once that country is selected
  if (value.usOnly) return country === 'US';
  if (value.canadaOnly) return country === 'CA';
  return true;
};

export const filterNonFoxdenProfessions = (
  professionChoices: Choice[],
  country?: BrokerCountry
): Choice[] => {
  const professionMapper = new Map(
    professions.map((value) => [
      value.profession.trim(),
      shouldRemove(value, country)
    ])
  );
  const newChoices = professionChoices.filter(
    (choice) => !professionMapper.get(choice.text.trim())
  );

  return newChoices;
};
